import { render, staticRenderFns } from "./ResourcesSection.vue?vue&type=template&id=22bee34a&scoped=true"
import script from "./ResourcesSection.vue?vue&type=script&lang=js"
export * from "./ResourcesSection.vue?vue&type=script&lang=js"
import style0 from "./ResourcesSection.vue?vue&type=style&index=0&id=22bee34a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bee34a",
  null
  
)

export default component.exports